import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserStateService } from '../../core/services/user-state.service';

export const redirectIfLoggedGuard: CanActivateFn = () => {
  const isLoggedIn = !!inject(UserStateService).userInfo()
  const router = inject(Router)
  if(isLoggedIn) return router.createUrlTree([''])
  return true
};
